import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getInventario, clearErrors } from '../../actions';
import { Pagination, Icon } from 'semantic-ui-react';

let timer = null;

const SearchInventario = (props) => {
  const { token, emisorId, isLoading, inventarioState, onSelectProducto } = props;
  const [buscarPor, setBuscarPor] = useState('');

  const onChangeSearch = (value) => {
    clearTimeout(timer);
    if (value?.length > 2 && !isLoading) {
      timer = setTimeout(() => props.getInventario(token, emisorId, 25, 1, value),
        500);
    }
    setBuscarPor(value);
  }

  useEffect(() => {
    listarProductos();
  }, []);

  const listarProductos = () => {
    props.getInventario(token, emisorId, 25, 1, '');
  }

  const cambioPagina = (e, info) => {
    props.getInventario(token, emisorId, 25, info.activePage, '');
  };

  const totalproductos = () => {
    let aux = inventarioState?.TotalRegistros;
    if (aux % 25 == 0) {
      return (aux / 25);
    }
    return ((aux / 25) + 1);
  };

  const paginacion = (total) => (
    <Pagination
      defaultActivePage={1}
      firstItem={null}
      lastItem={null}
      pointing
      secondary
      onPageChange={cambioPagina}
      totalPages={parseInt(total)}
    />
  )
  const enableLoading = () => {
    return isLoading ? 'ui active inverted dimmer' : 'ui disabled inverted dimmer';
  }

  return (
    <div className="search-container">
      <div className="ui grid">
        <div className="sixteen wide column">
          <div className="ui search">
            <div className="ui icon input">
              <input
                type="text"
                className="prompt"
                value={buscarPor}
                onChange={(e) => onChangeSearch(e.target.value)}
              />
              <i aria-hidden="true" className="search icon"></i>
            </div>
          </div>
        </div>
        <div className="sixteen wide column">
          <div className={enableLoading()}>
            <div className="ui text loader">Espere por favor...</div>
          </div>
          <div className="inventario-list">
            <ul className=" scroll-list list-group list-group-flush">
              {
                inventarioState?.Productos.map((item) => (
                  <div key={`prod_${item.Id}`} className="sixteen wide column inventario-list__item">
                    <button type="button" onClick={() => onSelectProducto(
                      {
                        ...item,
                        Detalle: item.Descripcion,
                        CodigoComercial: {
                          Tipo: item.Tipo,
                          Codigo: item.Codigo,
                        },
                        Codigo: item.CodigoCabys,
                      })}>
                      {item.Descripcion}
                    </button>
                  </div>
                ))
              }
            </ul>
          </div>
          {(inventarioState) && paginacion(totalproductos())}
          <span className="header-title">Total Productos: </span>
          <span className="text">{inventarioState?.TotalRegistros}</span>
          <span className="list"><Icon onClick={() => listarProductos()} className="listar" name="list" /></span>
          <span>Listar Productos</span>
        </div>
      </div>
    </div>
  )
};

SearchInventario.propTypes = {
  token: PropTypes.string.isRequired,
  emisorId: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
  return {
    errorState: state.errorState,
    inventarioState: state.inventarioState,
    isLoading: state.isLoadingState
  };
}

export default connect(mapStateToProps,
  {
    clearErrors,
    getInventario
  })(SearchInventario);
